"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const updateCompletionStatus_1 = require("../updateCompletionStatus");
const updateProgressMeasure_1 = require("../updateProgressMeasure");
const updateProgressStatusForIlt_1 = require("../updateProgressStatusForIlt");
function evaulateSession(command, user, content, draftStates) {
    const events = [];
    if (content && content.meta && content.meta.sessions) {
        for (const session of content.meta.sessions) {
            updateProgressStatusForIlt_1.updateProgressStatusForIlt(command, user, session, draftStates);
            const completionStatusEvents = updateCompletionStatus_1.updateCompletionStatus(command, user, session, draftStates, false);
            events.push(...completionStatusEvents);
        }
    }
    return events;
}
function evaluateILT(command, user, content, states) {
    const events = [];
    let updatedStates = states;
    updatedStates = immer_1.produce(updatedStates, draftStates => {
        const sessionStateEvents = evaulateSession(command, user, content, draftStates);
        const progressMeasureEvents = updateProgressMeasure_1.updateProgressMeasure(command, user, content, draftStates, false);
        updateProgressStatusForIlt_1.updateProgressStatusForIlt(command, user, content, draftStates);
        const completionStatusEvents = updateCompletionStatus_1.updateCompletionStatus(command, user, content, draftStates, false);
        events.push(...completionStatusEvents, ...sessionStateEvents, ...progressMeasureEvents);
    });
    return { events, states: updatedStates, stateInteractions: [] };
}
exports.evaluateILT = evaluateILT;
//# sourceMappingURL=index.js.map